import React from 'react'
import styles from './BillingWorksBanner.module.css'

const BillingWorksBanner = ({
  title = 'How Billing Works',
  text = 'We generate a bill when you use 100+ min or at the end of the month - whichever comes first.',
}) => {
  return (
    <div className={styles.banner}>
      <div className={styles.iconWrap}>
      <img src="/svg/Billing_work.svg" alt="Billing Works Icon" />
      </div>
      <div className={styles.textBlock}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.text}>{text}</p>
      </div>
    </div>
  )
}

export default BillingWorksBanner
